import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'

import Button from  'js/components/shared/Button'
import PopUp from '../../../PopupRedesign'
import {
  pushErrorOpenPopup,
  pushErrorClosePopup
} from '../../../../helpers/gtm'

import styles from './GlobalErrorPopUp.module.scss'

const cx = classnames.bind(styles)

const GlobalErrorPopUp = function ({data, onClose}) {
  const {
    message: {
      title,
      description,
      link,
    },
    onCloseFunc,
    onSubmitFunc,
  } = data;

  useEffect(function () {
    pushErrorOpenPopup()
    return function () {
      pushErrorClosePopup()
    }
  }, [])

  const onClickHandler = (e) => {
    onSubmitFunc ? onSubmitFunc(e, onClose) : closePopupHandler();
  }

  const closePopupHandler = () => {
    onCloseFunc ? onCloseFunc(onClose) : onClose();
  }

  return (
    <PopUp onClose={closePopupHandler}>
      <div className={cx('root')}>
        <p className={cx('title')}>
          {title}
        </p>
        <p
          className={cx('description')}
          dangerouslySetInnerHTML={{ __html: description }}
        />
        {!!link?.title && (<div className={cx('btn-holder')}>
          <Button
            onClick={onClickHandler}
            className={cx('btn')}
            theme="squared"
            size="lg"
            href={link.url || null}
          >
            {link.title}
          </Button>
        </div>)}
      </div>
    </PopUp>
  )
}

GlobalErrorPopUp.propTypes = {
  data: PropTypes.shape({
    message: PropTypes.objectOf(Object).isRequired,
    // onCloseFunc: PropTypes.func,
    // onClose: PropTypes.func.isRequired,
    // becomeMemberLinkText: PropTypes.string,
    // loginLinkText: PropTypes.string,
    // markedText: PropTypes.string,
    // memberRateText: PropTypes.string,
    // redirectToSecurePayment: PropTypes.func,
    // filterChangeAction: PropTypes.func.isRequired,
  }).isRequired
}

export default GlobalErrorPopUp
